class CookieUtils {
    constructor() {}

    adquirirCookie(nome) {
        const chamadaDoCookie = nome + "=";
        const cookiesDecodificados = decodeURIComponent(document.cookie);
        const cookieArray = cookiesDecodificados.split(';');
    
        for(let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(chamadaDoCookie) == 0) {
                return cookie.substring(chamadaDoCookie.length, cookie.length);
            }
        }
    
        return "";
    }
    
    verificarCookie(nome) {
        let cookie = this.adquirirCookie(nome);
        return cookie != "";
    }

}

export const cookieUtils = new CookieUtils()